// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/token.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ApproveDeviceAuthorizationRequest, ApproveDeviceAuthorizationResponse, CreatePersonalTokenRequest, CreatePersonalTokenResponse, CreateSearchKeyRequest, CreateSearchKeyResponse, CreateServiceAccountRequest, CreateServiceAccountResponse, CreateServiceAccountTokenRequest, CreateServiceAccountTokenResponse, DeleteServiceAccountRequest, DeleteServiceAccountResponse, DenyDeviceAuthorizationRequest, DenyDeviceAuthorizationResponse, GetSearchKeyUsageRequest, GetSearchKeyUsageResponse, GetServiceAccountRequest, GetServiceAccountResponse, IntrospectTokenRequest, IntrospectTokenResponse, ListPersonalTokensRequest, ListPersonalTokensResponse, ListSearchKeysRequest, ListSearchKeysResponse, ListServiceAccountsRequest, ListServiceAccountsResponse, ListServiceAccountTokensRequest, ListServiceAccountTokensResponse, PollDeviceAuthorizationRequest, PollDeviceAuthorizationResponse, RevokeSearchKeyRequest, RevokeSearchKeyResponse, RevokeTokenRequest, RevokeTokenResponse, StartDeviceAuthorizationRequest, StartDeviceAuthorizationResponse } from "./token_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.TokenService
 */
export const TokenService = {
  typeName: "omnios.v1.TokenService",
  methods: {
    /**
     * Personal Access Tokens
     *
     * @generated from rpc omnios.v1.TokenService.CreatePersonalToken
     */
    createPersonalToken: {
      name: "CreatePersonalToken",
      I: CreatePersonalTokenRequest,
      O: CreatePersonalTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TokenService.ListPersonalTokens
     */
    listPersonalTokens: {
      name: "ListPersonalTokens",
      I: ListPersonalTokensRequest,
      O: ListPersonalTokensResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TokenService.RevokeToken
     */
    revokeToken: {
      name: "RevokeToken",
      I: RevokeTokenRequest,
      O: RevokeTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Service Accounts
     *
     * @generated from rpc omnios.v1.TokenService.CreateServiceAccount
     */
    createServiceAccount: {
      name: "CreateServiceAccount",
      I: CreateServiceAccountRequest,
      O: CreateServiceAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TokenService.ListServiceAccounts
     */
    listServiceAccounts: {
      name: "ListServiceAccounts",
      I: ListServiceAccountsRequest,
      O: ListServiceAccountsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TokenService.GetServiceAccount
     */
    getServiceAccount: {
      name: "GetServiceAccount",
      I: GetServiceAccountRequest,
      O: GetServiceAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TokenService.DeleteServiceAccount
     */
    deleteServiceAccount: {
      name: "DeleteServiceAccount",
      I: DeleteServiceAccountRequest,
      O: DeleteServiceAccountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TokenService.CreateServiceAccountToken
     */
    createServiceAccountToken: {
      name: "CreateServiceAccountToken",
      I: CreateServiceAccountTokenRequest,
      O: CreateServiceAccountTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TokenService.ListServiceAccountTokens
     */
    listServiceAccountTokens: {
      name: "ListServiceAccountTokens",
      I: ListServiceAccountTokensRequest,
      O: ListServiceAccountTokensResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Device Authorization (RFC 8628)
     * StartDeviceAuthorization is unauthenticated (CLI calls it before login)
     *
     * @generated from rpc omnios.v1.TokenService.StartDeviceAuthorization
     */
    startDeviceAuthorization: {
      name: "StartDeviceAuthorization",
      I: StartDeviceAuthorizationRequest,
      O: StartDeviceAuthorizationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * User approves from the browser (authenticated)
     *
     * @generated from rpc omnios.v1.TokenService.ApproveDeviceAuthorization
     */
    approveDeviceAuthorization: {
      name: "ApproveDeviceAuthorization",
      I: ApproveDeviceAuthorizationRequest,
      O: ApproveDeviceAuthorizationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TokenService.DenyDeviceAuthorization
     */
    denyDeviceAuthorization: {
      name: "DenyDeviceAuthorization",
      I: DenyDeviceAuthorizationRequest,
      O: DenyDeviceAuthorizationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * CLI polls this (unauthenticated)
     *
     * @generated from rpc omnios.v1.TokenService.PollDeviceAuthorization
     */
    pollDeviceAuthorization: {
      name: "PollDeviceAuthorization",
      I: PollDeviceAuthorizationRequest,
      O: PollDeviceAuthorizationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Search Keys (Portal API)
     *
     * @generated from rpc omnios.v1.TokenService.CreateSearchKey
     */
    createSearchKey: {
      name: "CreateSearchKey",
      I: CreateSearchKeyRequest,
      O: CreateSearchKeyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TokenService.ListSearchKeys
     */
    listSearchKeys: {
      name: "ListSearchKeys",
      I: ListSearchKeysRequest,
      O: ListSearchKeysResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TokenService.RevokeSearchKey
     */
    revokeSearchKey: {
      name: "RevokeSearchKey",
      I: RevokeSearchKeyRequest,
      O: RevokeSearchKeyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.TokenService.GetSearchKeyUsage
     */
    getSearchKeyUsage: {
      name: "GetSearchKeyUsage",
      I: GetSearchKeyUsageRequest,
      O: GetSearchKeyUsageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Introspect the current bearer token (for `omnios agent whoami`)
     *
     * @generated from rpc omnios.v1.TokenService.IntrospectToken
     */
    introspectToken: {
      name: "IntrospectToken",
      I: IntrospectTokenRequest,
      O: IntrospectTokenResponse,
      kind: MethodKind.Unary,
    },
  }
};

